import {MouseEvent, useCallback} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Button} from '../../atoms/Button/Button';
import {ButtonColorScheme, ButtonSize} from '../../atoms/Button/Button.enum';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {RecentSearchesItemListProps} from './RecentSearchesItemListProps.interface';

export function RecentSearchesItemList({
  className,
  itemList,
  autoSaveRecentKeyword,
  onClickRemoveButton,
  onClickKeyword,
  ...props
}: RecentSearchesItemListProps) {
  const handleClickRemoveButton = useCallback(
    (event: MouseEvent<HTMLDivElement>, keyword: string) => {
      event.stopPropagation();
      onClickRemoveButton(keyword);
    },
    [onClickRemoveButton]
  );

  return (
    <div
      className={twMerge('flex h-32pxr w-full items-center', className)}
      {...props}
    >
      {!autoSaveRecentKeyword && (
        <Text className="font-small1 w-full text-center text-theme-solid-40">
          {t('search_recent_keyword_off_save')}
        </Text>
      )}
      {autoSaveRecentKeyword && itemList.length < 1 && (
        <Text className="font-small1 w-full text-center text-theme-solid-40">
          {t('search_recent_keyword_empty')}
        </Text>
      )}
      {autoSaveRecentKeyword && itemList.length > 0 && (
        <div className="flex space-x-6pxr overflow-x-scroll px-15pxr scrollbar-hide">
          {itemList.map((item, index) => {
            return (
              <Button
                key={item.keyword}
                size={ButtonSize.Medium}
                onClick={event =>
                  LOG_CLICK_EVENT('최근검색어_클릭', event, () =>
                    onClickKeyword(item.keyword)
                  )
                }
                colorScheme={ButtonColorScheme['3rd']}
                className="flex max-w-212pxr shrink-0 items-center pr-6pxr pl-12pxr"
                {...putTiaraObjectProps({
                  actionKind: 'Search',
                  click: {
                    ordnum: String(index + 1),
                    copy: item.keyword,
                  },
                  search: {
                    search_term: item.keyword,
                    search_type: '최근검색어',
                  },
                })}
              >
                <UrlLink
                  url={`/search/result?keyword=${encodeURIComponent(
                    item.keyword
                  )}`}
                >
                  <Text className="break-all line-clamp-1">{item.keyword}</Text>
                </UrlLink>
                <div
                  onClick={event => {
                    event.stopPropagation();
                    LOG_CLICK_EVENT('최근검색어_삭제_클릭', event, () =>
                      handleClickRemoveButton(event, item.keyword)
                    );
                  }}
                  className="relative ml-6pxr flex h-20pxr w-20pxr shrink-0 items-center justify-center"
                >
                  <Icon type={IconType.ButtonCloseS} className="m-4pxr" />
                </div>
              </Button>
            );
          })}
        </div>
      )}
    </div>
  );
}
